export enum FeeValueType {
  IDPS = "IDPS",
  Pension = "Pension",
  Other = "Other",
}
